import Swiper from 'swiper'
import {
  Autoplay,
  Pagination,
  Navigation,
  Thumbs,
  EffectFade,
} from 'swiper/modules'

document.addEventListener('DOMContentLoaded', () => {
  const swiperHeader = new Swiper('.swiperHeader', {
    slidesPerView: 1,
    initialSlide: 0,
    //loop: true,
    // effect: 'fade',
    allowTouchMove: false,
    // fadeEffect: {
    //   crossFade: true,
    // },
    speed: 4000,
    autoplay: {
      delay: 6000,
    },
    pagination: {
      el: '.swiper-pagination-header',
      type: 'bullets',
      clickable: true,
    },
    modules: [Pagination, EffectFade, Autoplay],
  })

  const swiperAccommodationConfig = {
    loop: true,
    slidesPerView: 1,
    spaceBetween: 32,
    speed: 2000,
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 28,
      },
      1280: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
      1360: {
        slidesPerView: 3,
        spaceBetween: 58,
      },
    },
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },
    pagination: {
      el: '.swiper-pagination',
      type: 'custom',
      renderCustom: function (swiper, current, total) {
        let paginationHtml = `
          <div class="font-sans text-xl text-white lg:text-2xl swiper-pagination-current">${current < 10 ? '0' + current : current}</div>
          <div class="w-10 h-px bg-gray-500 separator"></div>
          <div class="font-sans text-xl text-gray-500 lg:text-2xl swiper-pagination-total">${total < 10 ? '0' + total : total}</div>`
        return paginationHtml
      },
    },
    navigation: {
      nextEl: '.swiper-button-next-accommodation',
      prevEl: '.swiper-button-prev-accommodation',
    },
    modules: [Navigation, Pagination, Autoplay],
  }

  const swiperAccommodationSliders = document.querySelectorAll(
    '.swiperAccommodation'
  )
  swiperAccommodationSliders.forEach((element, index) => {
    new Swiper(element, {
      ...swiperAccommodationConfig,
    })
  })

  // const swiperOffersConfig = {
  //   slidesPerView: 1,
  //   loop: true,
  //   spaceBetween: 48,
  //   centeredSlides: true,
  //   grabCursor: true,
  //   breakpoints: {
  //     768: {
  //       slidesPerView: 2,
  //     },
  //     1024: {
  //       slidesPerView: 3,
  //     },
  //     1360: {
  //       slidesPerView: 4,
  //     },
  //   },
  //   speed: 2000,
  //   pagination: {
  //     el: '.swiper-pagination-offers',
  //     clickable: true,
  //   },
  //   modules: [Autoplay, Pagination],
  // };

  // const swiperOffersSliders = document.querySelectorAll('.swiperOffers')
  // swiperOffersSliders.forEach((element, index) => {
  //   new Swiper(element, {
  //     ...swiperOffersConfig,
  //   })
  // })

  const swiperGalleryConfig = {
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
    },
    spaceBetween: 1,
    speed: 2000,
    slidesPerGroup: 1,
    pagination: {
      el: '.swiper-pagination-gallery',
      clickable: true,
    },
    modules: [Navigation, Pagination],
  }

  const swiperGallerySliders = document.querySelectorAll('.swiperGallery')
  swiperGallerySliders.forEach((element, index) => {
    new Swiper(element, {
      ...swiperGalleryConfig,
      navigation: {
        nextEl: '.swiper-button-next-single-gallery-' + index,
        prevEl: '.swiper-button-prev-single-gallery-' + index,
      },
    })
  })

  const swiperSingleRoomThumbs = new Swiper('.swiperSingleRoomThumbs', {
    spaceBetween: 12,
    slidesPerView: 3,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      640: {
        slidesPerView: 4,
      },
      1024: {
        slidesPerView: 5,
      },
    },
    modules: [Thumbs],
  })

  const swiperSingleRoomMain = new Swiper('.swiperSingleRoomMain', {
    spaceBetween: 5,
    navigation: {
      nextEl: '.swiper-button-next-single-room',
      prevEl: '.swiper-button-prev-single-room',
    },
    thumbs: {
      swiper: swiperSingleRoomThumbs,
    },
    breakpoints: {
      1024: {
        spaceBetween: 5,
      },
    },
    modules: [Navigation, Thumbs],
  })

  const swiperOpinionsConfig = {
    slidesPerView: 1,
    loop: true,
    effect: 'fade',
    fadeEffect: {
      crossFade: true,
    },
    speed: 700,
    // autoplay: {
    //   delay: 5000,
    // },
    spaceBetween: 32,
    grabCursor: true,
    pagination: {
      el: '.swiper-pagination-opinions',
      type: 'bullets',
      clickable: true,
    },
    modules: [Pagination, Autoplay, EffectFade],
    autoplay: {
      delay: 5000,
      pauseOnMouseEnter: true,
    },
  }

  const swiperOpinionsSliders = document.querySelectorAll('.swiperOpinions')
  swiperOpinionsSliders.forEach((element, index) => {
    new Swiper(element, {
      ...swiperOpinionsConfig,
    })
  })
})
